// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__2EcCg","content":"PrivacyPolicyPage_content__2CC6M"};